// Re-export the main Supabase client for compatibility
export { supabase } from '../supabaseClient';

console.log('Supabase lib client - using main authentication client');
